import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { BrowseEl } from "common/widgets/browse";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".load-entity-modal", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("open") ? /* @__PURE__ */ jsx(ModalEl, { sel: ".modal.load-entity-modal", attrs: {
    closeable: true,
    open: this.attr("open"),
    "grow-to-content": true,
    elref: "loadModal"
  }, on: {
    change: this.handleLoadModalStateChange
  } }, /* @__PURE__ */ jsx("div", { sel: ".modal-inner-wrapper" }, /* @__PURE__ */ jsx(BrowseEl, { attrs: {
    elref: "browse"
  }, params: {
    entityTypeFilter: this.attr("entity-type-filter"),
    mode: this.attr("mode"),
    projectId: parseInt(this.attr("project-id"), 10),
    userId: this.attr("user-id"),
    searchText: this.state.searchedText,
    onRedirectToEntity: () => {
      this.triggerCloseModal();
    },
    onSelect: (result) => {
      const event = new CustomEvent("select", {
        detail: result
      });
      this.dispatchEvent(event);
    },
    onSearchedTextUpdate: (text) => {
      this.handleSearchedTextUpdated(text);
    }
  } }))) : null);
}
